import React from 'react';
import PropTypes from 'prop-types';
import Column from 'components/ui/show/Column';
import InnerColumn from 'components/ui/show/InnerColumn';
import Row from 'components/list/Filters/layout/Row';
import Section from 'components/ui/general/Section';
import TextInputField from 'material-ui/TextField';

class SingleFieldConfiguration extends React.Component {
    shouldComponentUpdate(nextProps) {
        return this.props.value !== nextProps.value;
    }

    render() {
        const {
            component: Component,
            errors,
            hintText,
            label,
            name,
            onChangeInput,
            title,
            value,
            ...restProps
        } = this.props;

        return (
            <Section>
                <Column title={ title } errorMessage={ errors[name] || '' }>
                    <InnerColumn>
                        <Row>
                            <Component
                                { ...restProps }
                                floatingLabelText={ label }
                                hintText={ hintText }
                                name={ name }
                                onChange={ (e) => {
                                    return onChangeInput(e);
                                } }
                                type='text'
                                value={ value }
                            />
                        </Row>
                    </InnerColumn>
                </Column>
            </Section>
        );
    }
}

SingleFieldConfiguration.defaultProps = {
    component: TextInputField,
};

SingleFieldConfiguration.propTypes = {
    choices: PropTypes.array,
    component: PropTypes.func,
    errors: PropTypes.object,
    hintText: PropTypes.string,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
};

export default SingleFieldConfiguration;


// WEBPACK FOOTER //
// ./src/pages/products/configuration/SingleFieldConfiguration.js